<template>
  <div id="chart4">
    <apexchart
      type="line"
      height="350"
      width="100%"
      :options="options"
      :series="series"
    ></apexchart>
  </div>
</template>

<script>
import VueApexCharts from "vue3-apexcharts";

export default {
  name: "ORGProductionProductivityByProducerExpShowProducerChartWeeklyReport",
  components: {
    apexchart: VueApexCharts
  },
  props: {
    data: { required: true },
    weeks: { required: true, type: Array },
  },
  data() {
    return {
      options: {
        chart: {
          height: 350,
          type: "line",
          zoom: {
            enabled: false
          }
        },
        stroke: {
          curve: "straight"
        },
        grid: {
          row: {
            colors: ["#f3f3f3", "transparent"],
            opacity: 0.5
          }
        },
        xaxis: {
          categories: this.weeks
        },
        yaxis: {
          title: {
            text: "Kilogramos"
          },
          labels: {
            formatter: function (val) {
              return this.numberWithPrecision(val, 0);
            }.bind(this)
          }
        },
        colors: ["#65A30D"],
        legend: {
          position: "top",
          horizontalAlign: "right",
          floating: false,
          offsetY: -25,
          offsetX: -5
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return this.numberWithPrecision(val);
            }.bind(this)
          }
        },
      }
    };
  },
  computed: {
    series() {
      return this.data.map(item => {
        return {
          name: item.name,
          data: item.productivity.map(p => p.productivity || 0)
        };
      });
    },
  }
};
</script>
